import { useRef, useState, useEffect } from 'react'
import styled from 'styled-components'
import { Box, BoxProps } from 'vvs-uikit'

const ScreenFooter: React.FC<BoxProps> = (props) => {
  const footerBox = useRef<HTMLDivElement>()
  const [height, setHeight] = useState(0)

  useEffect(() => {
    const onSizeChange = () => footerBox.current?.clientHeight && setHeight(footerBox.current.clientHeight)

    onSizeChange()
    const resizeObserver = new ResizeObserver(onSizeChange)
    resizeObserver.observe(footerBox.current)
    return () => resizeObserver.disconnect()
  }, [])

  return (
    <>
      <ScreenFooterSpace style={{ height: `${height}px` }} />
      <ScreenFooterBox ref={footerBox} {...props} />
    </>
  )
}

export default ScreenFooter

const ScreenFooterBox = styled(Box)`
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  bottom: 0;
  ${({ background, theme }) =>
    !background &&
    `
    background: ${theme.nav.background};
  `}
  padding: 16px;
`

const ScreenFooterSpace = styled(Box)`
  flex-shrink: 0;
`
